import { cloneDeep } from 'lodash';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

const localToken = localStorage.getItem('token') ? localStorage.getItem('token') : '';
const localVoicemodAccountId = localStorage.getItem('voicemodAccountId') ? localStorage.getItem('voicemodAccountId') : '';

const defaultState = {
    isTwitchLinked: false,
    token: localToken,
    twitchAuthToken: '',
    twitchChannelId: '',
    twitchClientId: '',
    twitchUserId: '',
    viewerIsLinked: false,
    viewerSubscriptionStatus: null,
    voicemodAccountId: localVoicemodAccountId,
};

export const globalStore = {
    namespaced: true,
    state: cloneDeep(defaultState),
    actions,
    mutations,
    getters,
};
